import Home from "../pages/Home";
import Faq from '../pages/Faq';
import FaqArticle from '../pages/FaqArticle';

export default [
  {
    name: 'home',
    url: '/',
    component: Home,
  },
  {
    name: 'faq',
    url: '/faq',
    component: Faq
  },
  {
    name: 'faqArticle',
    url: '/faq/article/:slug',
    component: FaqArticle,
  },
];